<template>
  <el-dialog :title="content.title" :visible.sync="visible" :close-on-click-modal="false" width="30%">
    <div>
      <el-tooltip placement="top">
        <div slot="content">Ce rappel correspond à un rendez-vous.</div>
        <el-switch v-model="form.meeting" on-text="RDV" off-text="RDV"
                   style="position: absolute; top: 20px; right: 50px;">
        </el-switch>
      </el-tooltip>
    </div>
    <el-form ref="form" label-position="top" label-width="150px" :model="form" :rules="fields.validation">
      <el-form-item v-if="!form.meeting" prop="date" label="Date du rappel">
        <el-date-picker v-model="form.date" v-on:click.native="form.date = null; form.date = moment()" type="date"
                        placeholder="Selectionnez une date" class="form-control"
                        :picker-options="fields.date" format="dd/MM/yyyy">
        </el-date-picker>
      </el-form-item>

      <el-row :gutter="20" v-if="form.meeting">
        <el-col :span="12">
          <el-form-item v-if="form.meeting" prop="date" label="Date et heure du rendez-vous">
            <el-date-picker v-model="form.date" type="datetime"
                            placeholder="Selectionnez une date et une heure" class="form-control"
                            :picker-options="fields.date" format="dd/MM/yyyy à HH:mm">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Durée (en minutes)" prop="meeting_duration">
            <el-input-number v-model="form.meeting_duration" :step="5" style="width: 100%"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item prop="category_id" label="Type">
            <el-select v-model="form.category_id" class="form-control" placeholder="Select">
              <el-option
                v-for="category in categories"
                :key="category.id"
                :label="category.name"
                :value="category.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="customer_id" label="Client">
            <el-select v-model="form.customer_id" filterable remote :remote-method="searchCustomer"
                       class="form-control" placeholder="Select">
              <customer v-for="customer in fields.customers" :key="customer.id" :item="customer" present="option"></customer>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item prop="description" label="Description">
        <el-input type="textarea" autosize placeholder="Saisissez la description de votre rappel"
                  v-model="form.description"></el-input>
      </el-form-item>

      <div class="text-center">
        <el-button type="text" v-on:click="advanced = !advanced">
          <i class="fa fa-sort-down"></i> Plus d'options

        </el-button>
      </div>

      <el-col v-if="advanced">
        <el-form-item label="Commercial" prop="user_id">
          <el-select v-model="form.user_id" class="form-control" placeholder="Select">
            <el-option
              v-for="user in users"
              :key="user.id"
              :label="user.name"
              :value="user.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Mis en avant" prop="important">
          <div class="form-control" style="border: 0">
            <el-radio class="radio" v-model="form.important" label="0">Non</el-radio>
            <el-radio class="radio" v-model="form.important" label="1">Oui</el-radio>
          </div>
        </el-form-item>
      </el-col>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button v-if="this.form.id !== null" type="danger" :plain="true" v-on:click.native="visible = false" v-delete:reminder="this.form"
                 class="pull-left">Supprimer</el-button>
      <el-button v-on:click="visible = false">Annuler</el-button>
      <el-button :type="content.button_type" v-on:click="submit()">{{ content.button }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import { MessageBox } from 'element-ui'
  import Customer from '../Entities/Customer.vue'
  import _ from 'lodash'

  export default {
    components: {Customer},
    name: 'reminder-modal',
    data () {
      return {
        visible: false,
        advanced: false,
        content: {
          title: '',
          button: '',
          button_type: ''
        },
        fields: {
          validation: {
            date: [
              {required: true, message: 'La date de rappel est invalide'}
            ],
            category_id: [
              {required: true, message: 'La catégorie du rappel est invalide'}
            ],
            user_id: [
              {required: true, message: 'Le commercial lié au rappel est invalide'}
            ]
          },
          date: {
            shortcuts: [{
              text: '+ 1 heure',
              onClick (picker) {
                const date = new Date()
                date.setTime(date.getTime() + 60 * 60 * 1000)
                picker.$emit('pick', date)
              }
            }, {
              text: '+ 2 heures',
              onClick (picker) {
                const date = new Date()
                date.setTime(date.getTime() + 2 * 60 * 60 * 1000)
                picker.$emit('pick', date)
              }
            }, {
              text: '+ 1 jour',
              onClick (picker) {
                const date = new Date()
                date.setTime(date.getTime() + 24 * 60 * 60 * 1000)
                picker.$emit('pick', date)
              }
            }, {
              text: '+ 2 jours',
              onClick (picker) {
                const date = new Date()
                date.setTime(date.getTime() + 2 * 24 * 60 * 60 * 1000)
                picker.$emit('pick', date)
              }
            }, {
              text: '+ 1 semaine',
              onClick (picker) {
                const date = new Date()
                date.setTime(date.getTime() + 7 * 24 * 60 * 60 * 1000)
                picker.$emit('pick', date)
              }
            }, {
              text: '+ 2 semaines',
              onClick (picker) {
                const date = new Date()
                date.setTime(date.getTime() + 2 * 7 * 24 * 60 * 60 * 1000)
                picker.$emit('pick', date)
              }
            }, {
              text: '+ 3 semaines',
              onClick (picker) {
                const date = new Date()
                date.setTime(date.getTime() + 3 * 7 * 24 * 60 * 60 * 1000)
                picker.$emit('pick', date)
              }
            }, {
              text: '+ 1 mois',
              onClick (picker) {
                const date = new Date()
                date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000)
                picker.$emit('pick', date)
              }
            }, {
              text: '+ 2 mois',
              onClick (picker) {
                const date = new Date()
                date.setTime(date.getTime() + 2 * 30 * 24 * 60 * 60 * 1000)
                picker.$emit('pick', date)
              }
            }]
          },
          customers: []
        },
        form: {
          meeting: false,
          id: null,
          date: null,
          category_id: _.get(this.keystone.config, 'components.modals.reminder.default_category', 1),
          description: '',
          user_id: this.$store.getters['users/current'].id,
          meeting_duration: 30,
          important: '0',
          customer_id: null
        }
      }
    },
    watch: {
      visible (visible) {
        if (!visible) {
          this.reset()
        }
      }
    },
    mounted () {
      let self = this

      this.$model.reminder.on('create', ({item}) => {
        self.content.title = 'Création d\'un rappel'
        self.content.button = 'Créer le rappel'
        self.content.button_type = 'success'

        self.load(item)

        self.visible = true
      })

      this.$model.reminder.on('edit', ({item}) => {
        self.content.title = 'Modification d\'un rappel'
        self.content.button = 'Modifier le rappel'
        self.content.button_type = 'warning'

        self.load(item)

        self.visible = true
      })

      this.$model.reminder.on('delete', ({item}) => {
        MessageBox.confirm('Souhaitez-vous réellement supprimer ce rappel ?', 'Confirmation', {
          confirmButtonText: 'Supprimer',
          cancelButtonText: 'Annuler',
          confirmButtonClass: 'el-button--danger'
        }).then(() => {
          self.$model.reminder.api().delete(item.id)
        }).catch(() => {

        })
      })
    },
    methods: {
      searchCustomer (query) {
        let self = this

        if (query.length > 2) {
          this.$nexus.get('crm2', 'customers/search', {params: {query}}).then(response => {
            self.fields.customers = response.data.data
          })
        }
      },
      reset () {
        this.form = this.$options.data.apply(this).form
        this.$refs['form'].resetFields()
      },
      load (item) {
        let self = this

        if (item) {
          if (item.id) this.form.id = item.id
          if (item.date) this.form.date = item.date.date
          if (item.category_id) this.form.category_id = item.category_id
          if (item.description) this.form.description = item.description
          if (item.user_id) this.form.user_id = item.user_id
          if (item.meeting) this.form.meeting = !!item.meeting
          if (item.meeting_duration) this.form.meeting_duration = item.meeting_duration
          if (item.important) this.form.important = item.important

          if (item.customer_id) {
            this.$nexus.get('crm2', 'customers', {params: {where: {id: item.customer_id}}}).then(response => {
              self.fields.customers = response.data.data
              self.form.customer_id = item.customer_id
            })
          }
        }
      },
      submit () {
        let self = this

        this.$refs['form'].validate((valid) => {
          if (valid) {
            let p

            if (this.form.id === null) {
              p = self.$model.reminder.api().create(this.form)
            } else {
              p = self.$model.reminder.api().update(this.form.id, {
                ...this.form,
                meeting_notifications: 0,
                meeting_displayed: 0,
                meeting_seen: 0
              })
            }

            p.then(() => {
              self.visible = false
            })
          } else {
            self.$message.error('Impossible de valider le formulaire. Merci de vérifier les valeurs saisies')
          }
        })
      }
    },
    computed: {
      user () {
        return this.$store.getters['users/current']
      },
      users () {
        return this.$store.getters['users/all']
      },
      categories () {
        return this.$store.getters['reminder_categories/all']
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ReminderModal.vue?349a90be